import { getWithSharedCache, fetchAsObservable } from 'fetcher!sofe';
import { pluck } from 'rxjs/operators';
import canopyUrls from 'canopy-urls!sofe';

export function getEngagement(clientId, engagementId) {
  if (!clientId) {
    throw new Error(`Cannot fetch engagement without client id`);
  }

  if (!engagementId) {
    throw new Error(`Cannot fetch engagement without engagment id`);
  }

  return fetchAsObservable(
    `${canopyUrls.getWorkflowUrl()}/api/clients/${clientId}/engagements/${engagementId}`
  ).pipe(pluck('engagements'));
}

export function patchEngagement({ clientId, engagementId, data }) {
  return fetchAsObservable(
    `/api/clients/${clientId}/engagements/${engagementId}`,
    {
      method: 'PATCH',
      body: {
        engagements: data
      }
    }
  ).pipe(pluck('engagements'));
}
